import React, { Component } from 'react';
import styled from 'styled-components';
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha";

import { MainContext } from '../../App';


const subjects = [
    {
        value: 0,
        label: 'Please select a reason for your enquiry*',
    },
    {
        value: 'TO_EMAIL_INTEGRATING:I would like to discuss integrating with Blueshyft',
        label: 'I would like to discuss integrating with Blueshyft'
    },
    {
        value: 'TO_EMAIL_SETUP:I would like to have the Blueshyft iPad setup in my retail store',
        label: 'I would like to have the Blueshyft iPad setup in my retail store'
    },
    // {
    //     value: 'TO_EMAIL_BITCOINOVER:I would like to buy Bitcoin over-the-counter',
    //     label: 'I would like to buy Bitcoin over-the-counter'
    // },
    {
        value: 'TO_EMAIL_OTHER:Other reason',
        label: 'Other reason'
    }
];

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();
        this.nameInput = React.createRef();
        this.emailInput = React.createRef();
        this.phoneInput = React.createRef();
    }

    state = {
        name: '',
        email: '',
        phone: '',
        reason: 0,
        message: '',
        errors: {
            name: false,
            email: false,
            phone: false,
        },
        submitted: false,
        recaptcha: undefined,
    }

    onChangeRecaptcha = (recaptcha) => {
        this.setState({ recaptcha })
    }

    submitForm = async () => {
        if (!this.state.recaptcha) return alert('Please complete the verification challenge');

        let { name, email, phone, reason, message } = this.state
        reason = reason !== 0 ? subjects[parseInt(reason)].value : 'TO_EMAIL_OTHER:Other reason'

        let errors = {};

        ['name', 'email', 'phone'].forEach(k => {
            errors[k] = !this.state[k] || !this[`${k}Input`].current.checkValidity()
        })

        errors['phone'] = errors['phone'] || !/^[0-9\+\(\)\-\.\_\*\#\s]+$/.test(phone)

        this.setState({ errors });

        if (Object.keys(errors).some(k => errors[k])) {
            return;
        }

        axios.post('/api/enquiries', {
            name, email, phone, reason, message,
        }).then((response) => {
            this.setState({ submitted: true });
        }).catch((e) => {
            alert(e);
        })


    }

    onChange = (e) => {
        const { errors } = this.state

        let name = e.target.name
        let update = {
            [name]: e.target.value
            
        }

        if (errors[name]) {
            update.errors = { ...errors, [name]: false }
        }

        this.setState(update)
    }

    render() { 
        const { context } = this.props
        const { name, email, phone, reason, message, errors, submitted } = this.state

        return (
            <React.Fragment>
                <ContactFormOverlay opened={context.contactFormOpened}/>
                <ContactFormContainer className={`contact ${context.contactFormOpened ? 'opened' : ''}`}>
                    <div className="scroll-container">
                        <span className="close-contact-menu" onClick={() => context.toggleContactForm(false)}>
                            <img src="/images/new/misc/menu-close.svg" />
                        </span>
                        <div className="scroll-container-wrapper">
                            <SuccessBlock submitted={submitted}>
                                <img src="/images/new/misc/confirm-button.svg" style={{ width: 200, marginBottom: 20 }} />
                                <h3 style={{ fontSize: 40 }}>THANK YOU</h3>
                                <p style={{ fontSize: 20, marginTop: 0, marginBottom: 25 }}>We will be in touch with you shortly</p>
                                <p style={{ fontSize: 20, marginTop: 35, color: "black", marginBottom: 10, color: '#464646' }}>Follow us</p>
                                <div className="socials" style={{ width: 150, marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
                                    <a href="https://twitter.com/blueshyft" target="_blank"><img style={{ width: 27 }} src="/images/new/icons/twitter-blue.svg" /></a>
                                    <a href="https://www.facebook.com/blueshyft/" target="_blank"><img style={{ width: 12 }} src="/images/new/icons/facebook-blue.svg" /></a>
                                    <a href="https://www.linkedin.com/company/blueshyft/" target="_blank"><img style={{ width: 25 }} src="/images/new/icons/linkedin-blue.svg" /></a>
                                </div>
                            </SuccessBlock>

                            <TitleBlock submitted={submitted}>

                                <h3>Want to know more?</h3>
                                <p>We'd love to chat or answer any questions you might have. 
                                Enter your details below, and we'll get right back to you.</p>

                            </TitleBlock>  

                            <Form className="form" submitted={submitted}>

                                <div className={`field ${errors.name ? 'error' : ''}`}>
                                    <input ref={this.nameInput} type="text" name="name" placeholder="Full Name *" value={name} onChange={this.onChange}/>
                                </div>

                                <div className={`field ${errors.email ? 'error' : ''}`}>
                                    <input ref={this.emailInput} type="email" name="email" placeholder="Email Address *" value={email} onChange={this.onChange}/>
                                </div>

                                <div className={`field ${errors.phone ? 'error' : ''}`}>
                                    <input ref={this.phoneInput} type="text" name="phone" placeholder="Phone Number *" value={phone} onChange={this.onChange}/>
                                </div>

                                <div className="drop-down field">
                                    <select id="subject" className={`${reason  !== 0 ? 'has-value' : ''}`} name="reason" value={reason} onChange={this.onChange}>
                                        {subjects.map((r,i) => <option key={i} disabled={i ===0 } value={i}>{r.label}</option>)}
                                    </select>
                                    <div className="select_arrow"></div>
                                </div>

                                <div className="message-field">
                                    <textarea name="message" placeholder="Your message here..." value={message} onChange={this.onChange}></textarea>
                                </div>

                            </Form>

                            <div style={{ display:  `${submitted ? 'none' : 'flex'}`, justifyContent: 'center', alignItems: 'center' }}>
                                <ReCAPTCHA
                                    ref={this.recaptchaRef}
                                    sitekey="6Lc7zysdAAAAAGWvn4wvU4iXXqZzDiaU8JH9guJW"
                                    onChange={this.onChangeRecaptcha}
                                />
                            </div>

                            <Submit className="submit enabled disable" submitted={submitted}>
                                <span onClick={this.submitForm}>SUBMIT</span>
                            </Submit>
                        </div>
                    </div>
                </ContactFormContainer>
            </React.Fragment>
        )
    }
}

export default (props) => (
    <MainContext.Consumer>
        { context => 
             <ContactForm context={context} />
        }
    </MainContext.Consumer>
)

export const OpenFormButton = ({onClick, ...props}) => (
    <MainContext.Consumer>
        { context => 
            <span onClick={() => { context.toggleContactForm(); onClick && onClick() }} {...props}>{props.children}</span>
        }
    </MainContext.Consumer>
)

const ContactFormContainer = styled.div`
 
`

const ContactFormOverlay = styled.div`
    background-color: transparent;
    display: ${props => props.opened ? 'block' : 'none'};
    height: 100%;
    width: 100%;
    z-index: 98;
    position: fixed;
    top: 0;
    left: 0;    
    overflow: hidden;
`

const Form = styled.form`
    display: ${props => props.submitted ? 'none': 'block'}
    margin: 0 4vw;
    padding: 20px;
    padding-bottom: 0px;
`

const TitleBlock = styled.div`
    padding-top: 50px;
    margin: 0 10px 40px 10px;
    display: ${props => props.submitted ? 'none': 'block'}
`

const SuccessBlock = styled.div`
    display: ${props => props.submitted ? 'flex': 'none'}
    margin-top: auto;
    margin-bottom: auto;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Submit = styled.div`
    display: ${props => props.submitted ? 'none': 'block'}
    padding: 20px;
    padding-top: 0px;
`



// WEBPACK FOOTER //
// ./client/components/ContactForm/index.js